"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecType = void 0;
exports.SpecType = Object.freeze({
    Series: 'series',
    Axis: 'axis',
    Annotation: 'annotation',
    Settings: 'settings',
    Tooltip: 'tooltip',
    IndexOrder: 'index_order',
    SmallMultiples: 'small_multiples',
});
//# sourceMappingURL=spec_type.js.map